
module.exports = {
    encode: require('./encode'),
    decode: require('./decode')
};



//////////////////
// WEBPACK FOOTER
// ../~/markup-it/lib/slate/index.js
// module id = 853
// module chunks = 0